import { getSimPropertyType } from "@/services/project/simulation.service"
import { getActiveUnitSetThunk, getProjectCasesThunk, getProjectPropertySetsThunk, getProjectSimulationsThunk, loadDimensionsThunk } from "@/store/project/actions"
import { useEffect } from "react"
import { useDispatch } from "react-redux"

interface DataContainerProps {
  fsId: string,
  projectId: string,
}
export function DataContainer(props: DataContainerProps) {

  const {fsId, projectId} = props; 
  const dispatch = useDispatch()

  useEffect(() => {
    const projectIdNum = Number(projectId)
    dispatch(getProjectCasesThunk({pId: projectIdNum}))
    dispatch(getProjectSimulationsThunk(Number(fsId)))
    dispatch(getProjectPropertySetsThunk({pId: projectIdNum}))
    dispatch(getActiveUnitSetThunk({projectId: projectIdNum}))
    dispatch(loadDimensionsThunk())
  }, [fsId, projectId])

  return null
}